<template>
  <div class="common-card mb-3">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="less">
@import "@/assets/common.less";
@import "@/styles/variables.less";

.common-card {
  width: 100%;
  position: relative;
  background-color: var(--card-grey-bg-color);
  padding: 3vw 3vw;
  border-top-left-radius: 3.5vw;
  border-bottom-right-radius: 4.5vw;
  cursor: not-allowed;
  contain: none;
  &::before {
    content: "";
    background: url("@{base-url}card_grey_left_top_icon.png") no-repeat;
    height: 3.5vw;
    width: 3.5vw;
    background-size: contain;
    position: absolute;
    left: 0;
    top: 0;
  }

  &::after {
    content: "";
    background: url("@{base-url}card_grey_right_bottom_icon.png") no-repeat;
    height: 5vw;
    width: 5vw;
    background-size: contain;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>
